import React from "react";
import Price from "./productsPrice";
import Barcode0 from "./Barcode0";
import PrintPaperShell from "./PrintPaperShell";
import "./PrintProducts.css";
import { elakayAutoText } from "./dataElakay";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["printerMyshop"]?.[key] || fallback;

/**
 * ===== PRINT PRODUCTS - OPTIMIZED FOR PAPER =====
 * With dangerouslySetInnerHTML for name/description
 * Color / Black & White toggle -- chrome (Print button, Color/B&W, Portrait/Landscape, footer)
 * now lives in the shared PrintPaperShell; this file keeps only the "My Shop" table shape.
 */

// Helpers

const calculateQuantities = (product) => {
  return product.filterProduct?.reduce((total, item) => total + (item.quantity || 0), 0) || 0;
};

const calculateSales = (product) => {
  return product.filterProduct?.reduce((total, item) => total + (item.sold || 0), 0) || 0;
};

const renderFiltersList = (product) => {
  const { filterProduct = [] } = product;

  if (!filterProduct.length) {
    return <span className="no-filters">{__elakayText("t001", "No variants")}</span>;
  }

  return (
    <div className="filters-inline-container">
      {filterProduct.map((item, itemIndex) => (
        <div key={itemIndex} className="filter-inline-item">
          <span className="filter-inline-badge">#{itemIndex + 1}</span>
          <span className="filter-inline-detail">
            <strong>{__elakayText("t002", "Qty:")}</strong> {item.quantity || 0}
          </span>
          <span className="filter-inline-detail">
            <strong>{__elakayText("t003", "Sold:")}</strong> {item.sold || 0}
          </span>
          {Object.entries(item.filter || {}).map(([key, value]) => (
            <span key={key} className="filter-inline-detail">
              <strong>{key}:</strong> {value}
            </span>
          ))}
        </div>
      ))}
    </div>
  );
};

// The "My Shop" printable table -- unchanged shape/classes from before the shell extraction.
const MyShopPrintTable = ({ myShop, infoSource }) => (
  <table className="print-paper-table">
    <thead>
      <tr>
        <th colSpan={5} className="table-header-logo">{__elakayText("t007", "www.elakay.com")}</th>
        <th className="table-header-qr">
          <Barcode0
            code={"qrcode"}
            height={14}
            scale={1}
            includetext={false}
            canvas={`qrcode-print`}
          />
        </th>
      </tr>
      <tr className="table-columns-header">
        <th className="col-id">#</th>
        <th className="col-name">
          {infoSource.laguangeElakay("label", infoSource.languageAPI).name || "Name"}
        </th>
        <th className="col-desc">
          {infoSource.laguangeElakay("label", infoSource.languageAPI).description || "Description"}
        </th>
        <th className="col-qty">
          {infoSource.laguangeElakay("label", infoSource.languageAPI).quantity || "Qty"}
        </th>
        <th className="col-sold">
          {infoSource.laguangeElakay("label", infoSource.languageAPI).sold || "Sold"}
        </th>
        <th className="col-price">
          {infoSource.laguangeElakay("label", infoSource.languageAPI).prix || "Price"}
        </th>
      </tr>
    </thead>

    <tbody>
      {myShop?.map((product, index) => {
        const totalQty = calculateQuantities(product);
        const totalSold = calculateSales(product);
        const rowClass = index % 2 === 0 ? "product-row-even" : "product-row-odd";

        return (
          <React.Fragment key={index}>
            <tr className={`product-main-row ${rowClass}`}>
              <td className="cell-id">{index + 1}</td>

              <td className="cell-name">
                <div
                  dangerouslySetInnerHTML={{
                    __html: product.name || "Untitled Product",
                  }}
                />
              </td>

              <td className="cell-desc">
                {product.description ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: product.description,
                    }}
                  />
                ) : (
                  <span className="text-muted">{__elakayText("t004", "No description")}</span>
                )}
              </td>

              <td className="cell-qty">
                <strong>{totalQty}</strong>
              </td>
              <td className="cell-sold">
                <strong>{totalSold}</strong>
              </td>
              <td className="cell-price">
                <Price products={product} showAddToCart={() => false} />
              </td>
            </tr>

            {product.filterProduct && product.filterProduct.length > 0 && (
              <tr className={`filters-row ${rowClass}`}>
                <td className="filters-label">
                  {infoSource.laguangeElakay("title", infoSource.languageAPI).filProduct || "Variants"}
                </td>
                <td colSpan={5} className="filters-content">
                  {renderFiltersList(product)}
                </td>
              </tr>
            )}
          </React.Fragment>
        );
      })}
    </tbody>
  </table>
);

// Main component
const PrintProductsPaper = (props) => {
  const { MyShop, infoSource } = props;
  __setElakayInfoSource(infoSource);

  return (
    <PrintPaperShell infoSource={infoSource} documentTitle="Elakay-Products" items={MyShop} itemNoun={elakayAutoText("h_pps_products_noun", "products")}>
      {() => <MyShopPrintTable myShop={MyShop} infoSource={infoSource} />}
    </PrintPaperShell>
  );
};

export default PrintProductsPaper;
